var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBengs = function SvgBengs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 88.531",
    height: "1em",
    width: "1em"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Bengs_svg__a",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h595v841.89H0V0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Bengs_svg__a)",
    transform: "matrix(4.43933 0 0 -4.43933 -277.91 1750.51)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ee1d23",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0c0 .127.049.252.142.34.09.096.212.146.342.146h3.977c.129 0 .252-.05.343-.146a.47.47 0 0 0 .14-.34v-2.77a.485.485 0 0 0-.483-.484H.484a.487.487 0 0 0-.342.137A.489.489 0 0 0 0-2.77V0Zm3.085-1.689a.38.38 0 0 1 .263.107c.07.07.107.164.107.262a.368.368 0 0 1-.107.267.36.36 0 0 1-.263.112H1.86a.374.374 0 0 1-.37-.379.368.368 0 0 1 .37-.369h1.225",
    transform: "translate(70.095 381.609)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ee1d23",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0c.101 0 .195.037.262.111.074.065.11.162.11.26 0 .1-.036.193-.11.266A.35.35 0 0 1 0 .744h-1.212a.373.373 0 0 1-.375-.373c0-.098.038-.195.109-.26A.367.367 0 0 1-1.212 0H0Zm.056 2.074c.099 0 .195.037.262.112a.368.368 0 0 1 .112.265.337.337 0 0 1-.112.26.35.35 0 0 1-.262.111h-1.325a.373.373 0 0 1-.263-.636.356.356 0 0 1 .263-.112H.056m-.251 3.168a1.016 1.016 0 0 1-.804.008l-.492-.229a.386.386 0 0 1-.21-.341.373.373 0 0 1 .372-.373H.115c.102 0 .198.041.265.111a.362.362 0 0 1 .108.262c0 .14-.08.275-.21.341l-.473.221M-3.923-5.869a1.487 1.487 0 0 0-.75-.201c-.261 0-.516.066-.741.197l-.003.002h-.009l.006-.002a.485.485 0 0 0-.233.418v4.166c0 .447.297.84.731.949l.991.266a.519.519 0 0 1 .383.5l-.078 2.793a.5.5 0 0 1-.151.357.506.506 0 0 1-.359.154l-.213-.046-.88-.413A.983.983 0 0 0-6.567 4.5a.95.95 0 0 0 .505.551l5.038 2.355c.13.059.274.094.42.094.146 0 .284-.035.417-.094l5.035-2.355a.939.939 0 0 0 .506-.551.99.99 0 0 0-.032-.752.987.987 0 0 0-1.308-.477l-.879.413-.21.046a.512.512 0 0 1-.509-.511L2.336.426c0-.235.158-.442.383-.5l.996-.266a.978.978 0 0 0 .728-.949v-4.166a.483.483 0 0 0-.238-.418l.008.002h-.009L4.2-5.873a1.457 1.457 0 0 0-.741-.197c-.258 0-.527.066-.752.199a.482.482 0 0 0-.228.416v3.008a.728.728 0 0 1-.211.508.721.721 0 0 1-.503.205h-4.744a.714.714 0 0 1-.711-.713v-3.008a.48.48 0 0 0-.233-.414",
    transform: "translate(73.173 384.376)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ee1d23",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0a7.783 7.783 0 0 0-7.781 7.783A7.78 7.78 0 0 0 0 15.563c4.3 0 7.779-3.481 7.779-7.78A7.778 7.778 0 0 0 0 0m0 17.529c-5.383 0-9.747-4.367-9.747-9.746C-9.747 2.4-5.383-1.963 0-1.963c5.382 0 9.748 4.363 9.748 9.746 0 5.379-4.366 9.746-9.748 9.746",
    transform: "translate(72.574 376.564)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ee1d23",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0h3.156a.75.75 0 0 1 .749.754.762.762 0 0 1-.754.764h-.753l.007 8.021h2.586v-.81c0-.434.362-.792.802-.792.443 0 .796.358.796.793l-.001 1.483c0 .455-.378.83-.837.83l-8.363-.002a.832.832 0 0 1-.831-.832l-.003-1.48a.793.793 0 1 1 1.587.005l-.009.813H.7V1.518H.009A.77.77 0 0 1-.752.754C-.752.338-.416 0 0 0",
    transform: "translate(87.492 378.458)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ee1d23",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0h2.371c.417 0 .757.338.757.754a.784.784 0 0 1-.779.764H1.98L.255 3.471l1.139.808H1.4l.46-.002c.413 0 .751.336.751.75a.75.75 0 0 1-.751.744H-.805a.746.746 0 0 1-.747-.744c0-.406.326-.73.719-.75l-.962-.67-.004 6.631a.803.803 0 0 1-.805.803l-1.516.002a.753.753 0 0 1 .004-1.504h.715l-.014-8.021h-.504a.754.754 0 0 1-.746-.764c0-.416.326-.754.746-.754h2.194c.415 0 .754.338.754.754s-.296.764-.712.764h-.112v.502l.861.621.996-1.131H.006A.756.756 0 0 1-.749.754C-.749.338-.42 0 0 0",
    transform: "translate(105.975 378.458)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ee1d23",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0a.754.754 0 0 0 .745-.762.743.743 0 0 0-.742-.754h-1.645a.752.752 0 0 0-.762.748c0 .399.353.77.75.77v2.162c.01.369-.228.574-.553.584a.726.726 0 0 1-.394-.086c-.51-.285-.798-.553-.798-1.211l.015-1.437c.42 0 .755-.36.766-.776a.764.764 0 0 0-.756-.761l-1.481.007a.75.75 0 0 0-.738.754c0 .405.336.768.741.768l.002 2.121c0 .299-.167.609-.546.619-.169 0-.341-.064-.418-.103-.488-.256-.776-.549-.776-1.207l.015-1.434c.405 0 .74-.367.74-.764a.752.752 0 0 0-.758-.754H-8.24a.737.737 0 0 0-.745.754c0 .416.335.764.754.764h.193l.005 2.76h-.198a.754.754 0 0 0-.754.75c0 .41.335.744.749.744h1.006a.77.77 0 0 0 .668-.367s.535.472 1.53.451c.802-.018 1.422-.686 1.422-.686.526.436 1.182.705 1.827.674.971-.027 1.597-.756 1.597-1.818L-.191.002",
    transform: "translate(148.881 379.974)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ee1d23",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0a.876.876 0 1 1 0-1.752c.481 0 .879.395.879.877A.88.88 0 0 1 0 0",
    transform: "translate(136.399 388.964)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ee1d23",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0h-.397l.003 3.469a.796.796 0 0 1-.813.791l-1.202-.006a.744.744 0 0 1-.746-.744c0-.418.331-.75.746-.75l.515.006L-1.897 0h-.505a.762.762 0 0 1-.753-.764c0-.416.33-.754.746-.754h2.377a.76.76 0 0 1 .761.754C.729-.348.415 0 0 0",
    transform: "translate(137.675 379.976)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ee1d23",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0a.739.739 0 0 0-.737-.738.733.733 0 0 0-.707.535c-.685.724-1.474.654-1.481.654-.209-.006-.378-.092-.448-.199L-3.375.25a.47.47 0 0 1-.063-.346c.023-.185.237-.304.241-.308.013-.008.234-.158 1.21-.465.787-.248 1.204-.443 1.207-.447.53-.246.843-.764.836-1.366 0-.672-.461-1.359-1.064-1.605-.304-.141-.648-.199-1.136-.178-.838.024-1.696.486-1.696.486a.73.73 0 0 0-.705-.507.735.735 0 0 0-.741.736l-.001 1.26c0 .4.332.734.729.734a.72.72 0 0 0 .723-.721v-.033c.354-.469.971-.734 1.676-.699 0 0 .38 0 .552.295v-.002l.022.299c-.051.199-.263.306-.714.476-.339.116-.977.334-1.106.385-.489.17-.8.348-.803.348-.547.291-.869.793-.853 1.344.033 1.218 1.221 1.552 1.23 1.556.216.076.551.113.864.113.738.018 1.582-.376 1.582-.376a.716.716 0 0 0 .648.394A.734.734 0 0 0 0 .889L-.002-.01",
    transform: "translate(124.174 382.867)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ee1d23",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0c-.816 0-1.483.664-1.483 1.484a1.484 1.484 0 0 0 2.966 0C1.483.664.819 0 0 0m3.701-.01c-.002 0-.632.182-.632.998l.003 2.748a.765.765 0 0 1-.771.764.77.77 0 0 1-.735-.539 2.98 2.98 0 0 1-1.571.457 2.94 2.94 0 0 1 0-5.879c.778 0 1.489.313 2.019.809 0 0 .648-.66 1.196-.778l.232-.037c.413 0 .751.336.751.75a.78.78 0 0 1-.492.707",
    transform: "translate(96.071 379.833)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ee1d23",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0a1.482 1.482 0 1 0 0 2.962A1.482 1.482 0 0 0 0 0m3.702-.01c-.004 0-.632.182-.632.998v2.748a.77.77 0 0 1-1.503.225 2.974 2.974 0 0 1-1.574.457 2.94 2.94 0 0 1 0-5.879c.783 0 1.492.313 2.02.809 0 0 .65-.66 1.196-.778l.234-.037a.75.75 0 0 1 .75.75c0 .315-.21.6-.491.707",
    transform: "translate(113.182 379.833)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ee1d23",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0c-.815 0-1.481.664-1.481 1.484a1.483 1.483 0 0 0 2.967 0C1.486.664.821 0 0 0m3.703-.01s-.63.182-.63.998l.003 2.748a.765.765 0 0 1-.772.764.774.774 0 0 1-.736-.539 2.98 2.98 0 0 1-1.572.457 2.937 2.937 0 0 1-2.934-2.941A2.935 2.935 0 0 1-.004-1.461c.783 0 1.493.313 2.02.809 0 0 .65-.66 1.198-.778l.231-.037a.75.75 0 0 1 .747.75.77.77 0 0 1-.489.707",
    transform: "translate(153.833 379.833)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ee1d23",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0a1.482 1.482 0 1 0 .003 2.961A1.482 1.482 0 0 0 0 0m3.702-.01s-.63.182-.63.998v2.748a.77.77 0 0 1-1.503.225A2.973 2.973 0 0 1 0 4.418a2.94 2.94 0 1 1 0-5.879c.776 0 1.487.313 2.013.809 0 0 .653-.66 1.198-.778l.233-.037a.75.75 0 0 1 .75.75.77.77 0 0 1-.492.707",
    transform: "translate(170.812 379.833)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ee1d23",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0a.752.752 0 0 1-.11-.395.79.79 0 0 1 .791-.789h1.923c.415 0 .748.338.748.758a.74.74 0 0 1-.738.75h-.666l3.514 6.627.558-.002a.748.748 0 1 1-.007 1.494H3.479a.745.745 0 1 1 0-1.492h.193L2.66 5.035 1.328 6.951l.248-.002c.411 0 .749.336.749.75 0 .41-.341.75-.755.75h-2.577a.744.744 0 0 1-.74-.75.75.75 0 0 1 .75-.75l.421.002 2.408-3.482",
    transform: "translate(160.312 375.786)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ee1d23",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0h-2.049a.762.762 0 0 0-.765.756c0 .42.324.758.743.758h.355v1.884c-.004.303-.068.516-.216.661a.719.719 0 0 1-.569.199c-.242.002-.358-.045-.522-.108a2.312 2.312 0 0 1-.834-.556s-.291-.309-.295-.59v-1.49h.238a.745.745 0 0 0 .742-.758A.746.746 0 0 0-3.917 0h-2.066c-.422 0-.727.344-.727.756 0 .42.326.758.746.758h.217l-.007 8.029h-.717a.76.76 0 0 0-.749.76c0 .414.307.736.722.736h1.525a.834.834 0 0 0 .825-.818l-.001-5.094c.42.359.894.533.898.539.28.111.537.184.96.189.544.022 1.062-.212 1.448-.601.389-.387.605-.85.605-1.399V1.514h.234a.761.761 0 0 0 .761-.76A.755.755 0 0 0 0 0",
    transform: "translate(132.496 378.462)"
  })));
};
export default SvgBengs;